import _ from 'lodash'
import moment from 'moment'
import { versions } from '../../modules/limits'

export default {
  nameIsAllowed: (name) => !_.includes(versions.forbiddenNames, name),
  nameIsUnique: ({ name, modelVersions }) => !_.includes(_.map(modelVersions, 'name'), name),
  formatDate: (version) => moment(+version * 1000).format('MMM Do YYYY, HH:mm')
}
